import { render, staticRenderFns } from "./heading-h1.vue?vue&type=template&id=67b73dc9"
import script from "./heading-h1.vue?vue&type=script&lang=js"
export * from "./heading-h1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports